module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iui-line-through"
  }, [_c('div', {
    staticClass: "iui-line-through-line",
    style: ({
      top: _vm.height / 2 + 'px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "iui-line-through-c"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab31754"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/line-through/line-through.vue
// module id = 80
// module chunks = 0 2 3 4 5 6 7 9